import { Index } from '@modules/missions/keaz/task'

export function KeazTask() {
  return <Index />
}
